module.exports = __webpack_public_path__ + "static/img/13.8ddc88d5.jpg";